var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{staticClass:"pt-30 mt-30 pl-30 pr-48 d-flex justify-content-between",attrs:{"show":true,"variant":"alert alert-card alert-danger"}},_vm._l((_vm.errors),function(error,index){return _c('div',{key:'error' + index},[_c('p',[_vm._v(_vm._s(error))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }